import EmailReader from "modules/backoffice/components/emailReader"

const formatGmailLabel = (value: string) => value.replaceAll("_", " ")

export default function BackofficeGmailReader() {
  return (
    <EmailReader
      basePath="/backoffice/gmailReader"
      i18nPrefix="backoffice.gmailReader"
      formatLabel={formatGmailLabel}
    />
  )
}
